import { useEffect, useState } from "react";
import * as TmdbApi from "../api/tmdb";

const Poster = (props) => {
    const { item, width, height } = props;
    const styles = createStyles(width, height);

    const [poster, setPoster] = useState(null);

    useEffect(() => {
        let isSubscribed = true;

        const loadPoster = async () => {
            try {
                const result = await TmdbApi.getPoster(item.ids.tmdb);
                if (isSubscribed) {
                    setPoster(result);
                }
            } catch (e) {
                console.log(`Failed to load poster for ${item.title}: ${e}`);
            }
        };

        if (item != null) {
            loadPoster();
        }

        return () => (isSubscribed = false);
    }, [item]);

    return (
        <>
            {poster != null ? (
                <div style={styles.poster}>
                    <img
                        src={poster}
                        style={styles.posterImg}
                        alt={item.title}
                    />
                </div>
            ) : (
                <div style={styles.emptyPoster} />
            )}
        </>
    );
};

const createStyles = (width, height) => {
    return {
        poster: {
            whiteSpace: "nowrap",
            margin: "2.5px",
            width: width,
            height: height,
        },
        posterImg: {
            width: width,
            height: height,
            objectFit: "scale-down",
        },
        emptyPoster: {
            margin: "2.5px",
            width: width,
            height: height,
            backgroundColor: "black",
            flexShrink: 0,
        },
    };
};

export default Poster;
